/**
 * Microsoft Clarity — eventos custom para segmentar grabaciones y heatmaps.
 *
 * Los "Smart Events" de Clarity permiten filtrar sesiones por estos tags:
 * p.ej. ver solo las grabaciones de quienes clickearon "Cotizar por WhatsApp".
 */

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

export function clarityEvent(name: string): void {
  if (typeof window.clarity !== 'function') return;
  window.clarity('event', name);
}

/** Eventos estandarizados del funnel B2B */
export const CLARITY_EVENTS = {
  LEAD_WHATSAPP_CORPORATIVO: 'lead_whatsapp_corporativo',
  COTIZAR_PEDIDO: 'cotizar_pedido',
  VER_AGENDAS: 'ver_agendas',
  CONTACT_WHATSAPP_WIDGET: 'contact_whatsapp_widget',
  CALLBACK_REQUEST: 'callback_request',
} as const;
